import { Skeleton, Typography } from '@iheartjane/reefer';
import type { Breadcrumb, Nullish } from '@iheartjane/types';

import { Breadcrumbs } from '@jane/bloom/components/breadcrumbs/breadcrumbs';
import { useSkeletonLoader } from '@jane/bloom/hooks/useSkeletonLoader';

import styles from './pageHeading.module.css';

interface PageHeadingProps {
  breadcrumbs?: Breadcrumb[];
  title: Nullish<string>;
}

// Sits below the menu header and above whatever follows (filters, deal cards);
// a custom description will join the title later.
export function PageHeading({ breadcrumbs, title }: PageHeadingProps) {
  const { skeletonLoader } = useSkeletonLoader();

  if (!title) return null;

  return (
    <div className={styles['pageHeading']}>
      {breadcrumbs && (
        <Breadcrumbs
          className={styles['breadcrumbs']}
          breadcrumbs={breadcrumbs}
        />
      )}
      {skeletonLoader ? (
        <Skeleton animate>
          <Skeleton.Bone
            data-testid="page-heading-skeleton"
            height={32}
            width={160}
          />
        </Skeleton>
      ) : (
        <Typography as="h2" variant="h2-semibold" color="text-main">
          {title}
        </Typography>
      )}
    </div>
  );
}
